import { useRef } from 'react';
import '../assets/css/gallery.css';
// import adherenceCalender from '../assets/images/datTbProject/adherence calender.png';
// import dashboard from '../assets/images/datTbProject/dashboard.jpeg';
// import login from '../assets/images/datTbProject/login.jpeg';

// import addCenter from '../assets/images/datTbProject/addCenter.png';
// import addNewStaff from '../assets/images/datTbProject/addNewStaff.png';
// import addOrgRegion from '../assets/images/datTbProject/addOrgRegion.png';
// import continuationPage from '../assets/images/datTbProject/continuationPage.png';
// import patientList from '../assets/images/datTbProject/patientList.png';

// import LazyLoad from 'react-lazyload';
// import SkeletonLoader from './SkeletonLoader';
import { datTbProjectImages, pmneProjectImages, geoDataVisualisationToolProjectImages } from '../utils/importImages'; // Dynamically loaded images


const Gallery = ({ projectIndex }) => {

    const projectImages = [
        pmneProjectImages,
        datTbProjectImages,
        geoDataVisualisationToolProjectImages
    ]

    const galleryBoxRef = useRef(null);
    let degrees = 0;
    const previewHandler = () => {
        degrees += 45;
        galleryBoxRef.current.style = `transform: perspective(1000px) rotateY(${degrees}deg)`;

    }

    const nextHandler = () => {
        degrees -= 45;
        galleryBoxRef.current.style = `transform: perspective(1000px) rotateY(${degrees}deg)`;

    }

    return (
        <div className="gallery-container">
            <div className="gallery-box" ref={galleryBoxRef}>
                <span className="gallery-box-1"><img src={projectImages[projectIndex].length > 0 ? projectImages[projectIndex][0] : ''} /></span>
                <span className="gallery-box-2"><img src={projectImages[projectIndex].length > 1 ? projectImages[projectIndex][1] : ''} /></span>
                <span className="gallery-box-3"><img src={projectImages[projectIndex].length > 2 ? projectImages[projectIndex][2] : ''} /></span>
                <span className="gallery-box-4"><img src={projectImages[projectIndex].length > 3 ? projectImages[projectIndex][3] : ''} /></span>
                <span className="gallery-box-5"><img src={projectImages[projectIndex].length > 4 ? projectImages[projectIndex][4] : ''} /></span>
                <span className="gallery-box-6"><img src={projectImages[projectIndex].length > 5 ? projectImages[projectIndex][5] : ''} /></span>
                <span className="gallery-box-7"><img src={projectImages[projectIndex].length > 6 ? projectImages[projectIndex][6] : ''} /></span>
                <span className="gallery-box-8"><img src={projectImages[projectIndex].length > 7 ? projectImages[projectIndex][7] : ''} /></span>
            </div>
            <div className="gallery-btns">
                <div className="btn prev" onClick={previewHandler}></div>
                <div className="btn next" onClick={nextHandler}></div>

            </div>
        </div>
    );
}

export default Gallery;